import { render, staticRenderFns } from "./StaffAdminPage.vue?vue&type=template&id=7cd5cb14&scoped=true&"
import script from "./StaffAdminPage.vue?vue&type=script&lang=js&"
export * from "./StaffAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5cb14",
  null
  
)

export default component.exports